import { render, staticRenderFns } from "./r-search-filter.vue?vue&type=template&id=0e607696"
import script from "./r-search-filter.vue?vue&type=script&lang=js"
export * from "./r-search-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e607696')) {
      api.createRecord('0e607696', component.options)
    } else {
      api.reload('0e607696', component.options)
    }
    module.hot.accept("./r-search-filter.vue?vue&type=template&id=0e607696", function () {
      api.rerender('0e607696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/search/r-search-filter.vue"
export default component.exports